<aside>
  <div class="message {{messageStyle}}">
    <i class="material-icons notranslate">{{messageIcon}}</i>
    <span [innerHTML]="actionDescription"></span>
  </div>
</aside>
